import axios from 'axios'

const kongProdDefaultUrl = 'https://apigw.olx.com.br'

const readGlobal = () => {
  try {
    return globalThis?.OLX_KONG_URL ?? null
  } catch {
    return null
  }
}

let runtimeBaseUrl = null

export const resolveBaseUrl = () =>
  runtimeBaseUrl || readGlobal() || process.env.REACT_APP_KONG_URL || kongProdDefaultUrl

export const axiosInstance = axios.create({
  baseURL: resolveBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
    'X-OLX-TEAM-KEY': '5XzjuCgmYE7qMlYpsLZbTvm98ik4CS4a',
  },
  withCredentials: true,
  timeout: 10000,
})

// garante baseURL certo MESMO se o host setar depois do import
axiosInstance.interceptors.request.use(cfg => {
  cfg.baseURL = resolveBaseUrl()
  return cfg
})

export const setDefaultUrl = baseUrl => {
  runtimeBaseUrl = baseUrl
  axiosInstance.defaults.baseURL = baseUrl
}

export const setAuthHeader = accessToken => {
  axiosInstance.defaults.headers.common.Authorization = accessToken
}

export const removeAuthHeader = () => {
  delete axiosInstance.defaults.headers.common.Authorization
}

export { axiosInstance as axios }
